<template>
  <div>
    <div v-if="loading" :class="{ 'main-loader': loading }">
      <div class="loader-cnt">
        <img src="@/assets/main_logo.svg" width="200" alt="PayAngel" />
        <p class="mb-0">Please wait...</p>
      </div>
    </div>
    <div v-if="refloading" class="main-loader">
      <div class="loader-cnt">
        <img src="@/assets/main_logo.svg" width="200" alt="PayAngel" />
        <p class="mb-0">Please wait...</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LoaderComponent",
  props: {
    loading: Boolean,
  },
  data() {
    return {
      refloading: false,
    };
  },
  methods: {
    show() {
      this.refloading = true;
    },

    hide() {
      this.refloading = false;
    },
  },
};
</script>
